module.exports = __webpack_public_path__ + "img/promotor.48b1260a.svg";